export function constructSnippet(
  twinkleSpeed: number,
  isToggled: boolean
) {
  return `
<style>
  @keyframes twinkle {
    from {
      opacity: 0.25;
    }
    to {
      opacity: 0.75;
    }
  }

  @keyframes fadeFromTransparent {
    from {
      opacity: 0;
    }
  }

  .ball {
    animation:
      twinkle ${twinkleSpeed}ms alternate infinite,
      fadeFromTransparent 2000ms;
  }
</style>

${isToggled ? `<div class="ball"></div>` : ' '}
`;
}
